import styled from "styled-components"
import media from "styled-media-query"

/* import { Link } from "gatsby" */

import { Whatsapp } from "styled-icons/boxicons-logos/Whatsapp"
import { MailOutline as Mail } from "styled-icons/material/MailOutline"

export const FooterWrapper = styled.footer`
  background: ${props => props.theme.colors.powderWhite};
  border-top: 1px solid #ccc;
  min-height: 8em;
  padding: ${props => props.theme.padding};
  padding-top: 2em;
  padding-bottom: 4em;
`
export const FooterContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  max-width: ${props => props.theme.maxWidth};
  text-align: center;
  /* width: 100%; */

  ${media.greaterThan("medium")`
    flex-direction: row;
    justify-content: space-between;
  `}
`

export const FooterGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${media.greaterThan("medium")`
    flex-direction: row;
  `}
`

export const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const FooterList = styled.ul`
  margin: 0.5em 0;
  text-align: center;

  &:last-of-type {
    margin-right: 0;
  }

  ${media.greaterThan("medium")`
    margin: 0 2em;
  `}
`

export const FooterListTitle = styled.h2`
  color: #393e46;
  font-size: 1.2em;
`

export const FooterItem = styled.li`
  margin: 0.1em 0;

  &:first-of-type {
    margin-top: 1em;
  }
`

export const FooterLink = styled.a`
  color: inherit;
  font-weight: 500;
  opacity: 0.8;
  text-decoration: none;

  &:hover {
    opacity: 1;
  }
`

export const FooterIconWhatsapp = styled(Whatsapp)`
  color: ${props => props.theme.colors.highlight};
  height: 1.25em;
  margin: 0 0.2em;
`

export const FooterIconMail = styled(Mail)`
  color: ${props => props.theme.colors.highlight};
  height: 1.25em;
  margin: 0 0.2em;
`
export const FooterText = styled.p`
  color: ${props => props.theme.colors.border};
  font-size: ${props => props.theme.fontSizes.small};
  margin-top: 5em;
  text-align: center;
`
